import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { Button } from "@altimateai/lego";

interface ClearFiltersProps {
  /**
   * URL search-param keys to keep when clearing filters. Routes that put
   * route-level state (date range, sort, pagination, granularity) in the URL
   * should pass those keys here so "Clear filters" only wipes filter tags.
   */
  keysToPreserve?: string[];
}

const ClearFilters = ({ keysToPreserve }: ClearFiltersProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { clearSearchParams } = useFiltersBySearchParams();

  const handleClick = useCallback(() => {
    if (!keysToPreserve?.length) {
      clearSearchParams();
      return;
    }
    const next = new URLSearchParams();
    keysToPreserve.forEach(key => {
      searchParams.getAll(key).forEach(value => next.append(key, value));
    });
    setSearchParams(next.toString(), { replace: true });
  }, [keysToPreserve, clearSearchParams, searchParams, setSearchParams]);

  return (
    <Button variant="link" onClick={handleClick}>
      Clear filters
    </Button>
  );
};

export default ClearFilters;
